<template>
	<div class="control-button-container"
		:class="{'basics-button': basicsCss}"
	 	@click="buttonClick"
	>
		<slot></slot>
	</div>
</template>

<script>
	import {defineComponent} from "vue"
	import { ElMessageBox } from 'element-plus'
	
	export default defineComponent({
		name: "controlButton",
		props: {
			useConfirm: {
				type: Boolean,
				default: false
			},
			comfirmMessage: {
				type: String,
				default: "这是一段内容确定删除吗？"
			},
			comfirmOkText: {
				type: String,
				default: "好的"
			},
			comfirmCancelText: {
				type: String,
				default: "不用了"
			},
			basicsCss: {
				type: Boolean,
				default: false
			}
		},
		emits:["buttonClick"],
		setup(props, {emit}){
			let methods = {
				buttonClick() {
					if (props.useConfirm) {
						ElMessageBox.confirm(props.comfirmMessage, '提示', {
							confirmButtonText: props.comfirmOkText,
							cancelButtonText: props.comfirmCancelText,
							type: 'warning'
						}).then(() => {
							emit("buttonClick")
						}).catch(() => {})
					} else {
						emit("buttonClick")
					}
				}
			}
			
			return {
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.control-button-container {
		padding-left: 22px;
		padding-right: 22px;
		box-sizing: border-box;
		width: fit-content;
		height: 30px;
		border-radius: 4px;
		border-width: 1px;
		border-style: solid;
		@include background_color("control-button-bg-color");
		cursor: pointer;
		white-space: nowrap;
		font-size: 18px;
		line-height: 18px;
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: center;
		padding-top: 1px;

		&:hover {
			opacity: 0.6;
		}
	}

	// 基本事件按钮
	.basics-button {
		box-sizing: border-box;
		@include border_all("add-button-border");
		@include font_color("add-button-font-color");
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: space-around;

		.basics-button-icon {
			margin-right: 10px;
		}
	}
</style>
